'use es6';

import { Modal } from 'foundations-components/transitional/components/Modal';
import { ModalDialog } from 'foundations-components/transitional/components/ModalDialog';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Form } from 'foundations-components/transitional/components/Form';
import { H4 } from 'foundations-components/transitional/components/H4';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SequenceUnenrollConfirmationDialog({
  onConfirm,
  onReject
}) {
  const onSubmit = evt => {
    evt.preventDefault();
    onConfirm();
  };
  return /*#__PURE__*/_jsx(ModalDialog, {
    onEsc: onReject,
    children: /*#__PURE__*/_jsxs(Form, {
      onSubmit: onSubmit,
      children: [/*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sequencesCrmLib.contactHighlightBadge.unenrollConfirmation.message"
          })
        })
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          type: "submit",
          use: "primary",
          "data-test-id": "unenroll-confirm-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sequencesCrmLib.contactHighlightBadge.unenrollConfirmation.confirmLabel"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onReject,
          use: "tertiary-light",
          "data-test-id": "unenroll-reject-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sequencesCrmLib.contactHighlightBadge.unenrollConfirmation.rejectLabel"
          })
        })]
      })]
    })
  });
}
export default function SequenceUnenrollConfirmation(props = {}) {
  return /*#__PURE__*/_jsx(Modal, Object.assign({}, props, {
    ModalDialog: SequenceUnenrollConfirmationDialog
  }));
}